namespace TabAurous.Production {
    export interface ReceiptMaterialDetailsRow {
        TransDetailId?: number;
        TransId?: number;
        TransDate?: string;
        PartyId?: number;
        DepartmentId?: number;
        VoucherTypeId?: number;
        ProductId?: number;
        ProductCode?: string;
        AttributeId?: number;
        Attribute?: string;
        BagNo?: string;
        SubBagNo?: number;
        SKU?: string;
        Line_No?: number;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        DiamondPieces?: number;
        DiamondWeight?: number;
        StonePieces?: number;
        StoneWeight?: number;
        OtherPieces?: number;
        OtherWeight?: number;
        CompanyId?: number;
        FinancialYearId?: number;
        RefVoucherId?: number;
        RefTransId?: number;
        RefTransDetailId?: number;
        ItemDetails?: ReceiptMaterialItemsRow[];
    }

    export namespace ReceiptMaterialDetailsRow {
        export const idProperty = 'TransDetailId';
        export const nameProperty = 'BagNo';
        export const localTextPrefix = 'Production.ReceiptMaterialDetails';
        export const deletePermission = 'Production:ReceiptMaterial:Delete';
        export const insertPermission = 'Production:ReceiptMaterial:Add';
        export const readPermission = '*';
        export const updatePermission = 'Production:ReceiptMaterial:Edit';

        export declare const enum Fields {
            TransDetailId = "TransDetailId",
            TransId = "TransId",
            TransDate = "TransDate",
            PartyId = "PartyId",
            DepartmentId = "DepartmentId",
            VoucherTypeId = "VoucherTypeId",
            ProductId = "ProductId",
            ProductCode = "ProductCode",
            AttributeId = "AttributeId",
            Attribute = "Attribute",
            BagNo = "BagNo",
            SubBagNo = "SubBagNo",
            SKU = "SKU",
            Line_No = "Line_No",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            DiamondPieces = "DiamondPieces",
            DiamondWeight = "DiamondWeight",
            StonePieces = "StonePieces",
            StoneWeight = "StoneWeight",
            OtherPieces = "OtherPieces",
            OtherWeight = "OtherWeight",
            CompanyId = "CompanyId",
            FinancialYearId = "FinancialYearId",
            RefVoucherId = "RefVoucherId",
            RefTransId = "RefTransId",
            RefTransDetailId = "RefTransDetailId",
            ItemDetails = "ItemDetails"
        }
    }
}
